import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/feedback', { params })
  },
  store (formData) {
    return apiClient.post('/feedback', formData)
  },
  show (id, params) {
    return apiClient.get(`/feedback/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/feedback/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/feedback/${id}`)
  }
}
